import React from "react";
import ParticipantListItem from "./ParticipantListItem";
import LoadingComponent from "../../components/common/LoadingComponent";
import { useConversationContext } from "./ConversationContext";

function MessageListColumn({ listData }) {
  const { meta } = useConversationContext();
  const { group, isLoading } = meta;
  const { participantGroups, selectedParticipant, onSelectParticipant } =
    listData;

    return (
    <div className="d-flex flex-column border-end border-secondary-subtle conv-list-column">
      <div className="flex-grow-1 px-2 py-3 conv-list-scroll">
        {isLoading ? (
          <LoadingComponent loading={true} size={6} />
        ) : !group.messages?.length ? (
          <div className="text-center text-body-secondary py-5">
            <i className="bi bi-chat-slash fs-2 d-block mb-2" />
            No messages in this conversation
          </div>
        ) : (
          (participantGroups || []).map((integration) => (
            <div key={integration.integrationKey} className="mb-3">
              <div className="d-flex flex-column">
                {(integration.participants || []).map((participant) => (
                  <ParticipantListItem
                    key={participant.participantKey}
                    participant={participant}
                    isMessageGrouped={participant?.messages?.length > 1}
                    isSelected={
                      selectedParticipant?.integrationKey === integration.integrationKey &&
                      selectedParticipant?.participantKey === participant.participantKey
                    }
                    onSelect={() =>
                      onSelectParticipant(integration.integrationKey, participant.participantKey)
                    }
                  />
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default MessageListColumn;